// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__vmFqN","button_outline":"Button_button_outline__yJdjN","button_small":"Button_button_small__xCJdE"};